/** @jsx jsx */
import React from "react"
import { jsx } from "@emotion/core"
import { colors } from "../styles"

export const Heading2 = ({ children, ...props }) => (
  <h2
    css={{
      color: colors.BLUE,
      fontWeight: 100,
      textAlign: "center",
      marginBottom: "1rem",
    }}
  >
    {children}
  </h2>
)
